<template>
    <section id="vue-render" class="vue-render-component page-section">
        <div class="container">
            <header class="main-title title">Vue Rendering</header>
            <p>We know how working Vuejs render, but now I want to see you few examples for best understanding how we
                need
                working with it. So. let's go!</p>
            <p>Vue Rendering example:</p>
            <button v-if="!isOpenCode" @click="hideShowCode">Show code</button>
            <button v-if="isOpenCode" @click="hideShowCode">Hide code</button>
            <div v-show="isOpenCode" class="code-container">

                <div>HTML</div>

                <pre class="language-markup">
          <code>

            &lt;p&gt;This is count for addCountFunction: { { count } } &lt;/p&gt;

            &lt;p&gt;This is function to display count by displayCountFunction: { { displayCountFunction() } }&lt;/p&gt;

            &lt;p v-if="infiniteLoop"&gt;This is function to display count by displayCountFunctionWithCountChange:
            { { displayCountFunctionWithCountChange() } }&lt;/p&gt;

            &lt;button @click="addCountFunction"&gt;Add count&lt;/button&gt;
            &lt;button @click="resetCountFunction"&gt;Reset count&lt;/button&gt;
            &lt;button @click="infiniteLoopFunction()"&gt;Infinite Loop&lt;/button&gt;
          </code>
        </pre>

                <div>JS</div>
                <pre class="language-js">
          <code>

            methods: {
                addCountFunction() {
                  this.count = ++this.count;
                },
                resetCountFunction() {
                  this.count = 0;
                },
                displayCountFunction() {
                  alert('displayCountFunction rendered')
                },
                displayCountFunctionWithCountChange(){
                  this.count++;
                  alert('displayCountFunctionWithCountChange rendered')
                },
                infiniteLoopFunction() {
                  this.infiniteLoop = true;
                },
                hideShowCode() {
                  this.isOpenCode = !this.isOpenCode;
                }
            }

          </code>
        </pre>

            </div>

            <div class="description">
                <p>Description:</p>
                <p>We know how Vuejs render is working, but now I want to show you few examples for better understanding
                    of how
                    we need to deal with that.</p>
                <p>If we use variable from data in html and change it: html is rendering (and run all functions in
                    HTML).</p>
                <p>So if we use functions in html like displayCountFunction - it's OK, because it's pure function
                    (without any
                    side effects).</p>
                <p>But if we use function like displayCountFunctionWithCountChange - that is a problem.</p>
                <p>Function displayCountFunctionWithCountChange change count, so we get html re-rendering and run all
                    functions,
                    because we using count variable in html.
                </p>
                <p>First run function displayCountFunction without render, after it run function
                    displayCountFunctionWithCountChange and change count again.</p>
                <p>So we get infinite loop</p>
            </div>


            <p>This is count for addCountFunction: {{ count }}</p>
            <p>This is function to display count by displayCountFunction: {{ displayCountFunction() }}</p>
            <p v-if="infiniteLoop">This is function to display count by displayCountFunctionWithCountChange:
                {{ displayCountFunctionWithCountChange() }}</p>

            <button @click="addCountFunction">Add count</button>
            <button @click="resetCountFunction">Reset count</button>
            <button :disabled='count>10' @click="infiniteLoopFunction()">Infinite Loop</button>

            <p>*Infinite Loop until the count goes over 10</p>
        </div>
    </section>
</template>

<script>

import "prismjs/themes/prism.css"

export default {
    name: "VueRenderComponent",
    data() {
        return {
            count: 0,
            infiniteLoop: false,
            isOpenCode: false
        }
    },
    created() {

    },
    methods: {
        addCountFunction() {
            this.count = ++this.count;
        },
        resetCountFunction() {
            this.count = 0;
        },
        displayCountFunction() {
            alert('displayCountFunction rendered')
        },
        displayCountFunctionWithCountChange() {
            if (this.count <= 10) {
                this.count++;
                alert('displayCountFunctionWithCountChange rendered')
            } else {
                this.infiniteLoop = false;
                alert('infiniteLoop was stopped by count')
            }
        },
        infiniteLoopFunction() {
            this.infiniteLoop = true;
        },
        hideShowCode() {
            this.isOpenCode = !this.isOpenCode;
        },
    }
}
</script>

<style lang="scss" scoped>
#vue-render.vue-render-component {
    background-color: #ffffff;
    width: 100%;

    button {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 35px;
        width: 95px;
        margin: 15px 0;
        cursor: pointer;
        padding: 0;
    }

    .container {
        .description {
            max-width: 900px;
        }

        .code-container {
            margin: 15px;
            padding: 10px;
            box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.3);
        }
    }
}
</style>